(function ($) {
    'use strict';
    $(function () {
        // Filtering no layout mode
        Isotope.Item.prototype._create = function () {
            // assign id, used for original-order sorting
            this.id = this.layout.itemGUID++;
            // transition objects
            this._transn = {
                ingProperties: {},
                clean: {},
                onEnd: {}
            };
            this.sortData = {};
        };

        Isotope.Item.prototype.layoutPosition = function () {
            this.emitEvent('layout', [this]);
        };

        Isotope.prototype.arrange = function (opts) {
            // set any options pass
            this.option(opts);
            this._getIsInstant();
            // just filter
            this.filteredItems = this._filter(this.items);
            // flag for initalized
            this._isLayoutInited = true;
        };

        // layout mode that does not position items
        Isotope.LayoutMode.create('none');

        var $works = $('.works').isotope({
            layoutMode: 'none',
            transitionDuration: 0,
            hiddenStyle: {
                opacity: 0
            },
            visibleStyle: {
                opacity: 1
            }
        });
        $('.filters > li').on('click', 'a', function () {
            var filterValue = $(this).attr('data-filter');
            $works.isotope({layoutMode: 'none', filter: filterValue});
        });
    });
})(jQuery);